<template>
    <div>
        <Spinner/>
        <slot></slot>
    </div>
</template>

<script>
    import Spinner from '../../../core/Components/Spinner.vue'

    export default {
        name: 'PageBaseNoHeader',
        components: {Spinner}
    }
</script>